/**
 * Small formatting helpers shared by the Connected Apps and Connector admin pages.
 * Connector timestamps are the platform's yyyyMMddHHmmss decimals; 0 means "never".
 */
import { CONNECTOR_SCOPE_LABELS } from '@actschurch/ccms-sdk';

export function stampToDate(stamp?: number | null): Date | null {
  if (!stamp || stamp <= 0) return null;
  const s = String(Math.trunc(stamp)).padStart(14, '0');
  const y = Number(s.slice(0, 4));
  const mo = Number(s.slice(4, 6)) - 1;
  const d = Number(s.slice(6, 8));
  const h = Number(s.slice(8, 10));
  const mi = Number(s.slice(10, 12));
  const sec = Number(s.slice(12, 14));
  const date = new Date(Date.UTC(y, mo, d, h, mi, sec));
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatStamp(stamp?: number | null, fallback = 'never'): string {
  const date = stampToDate(stamp);
  return date ? date.toLocaleString() : fallback;
}

export function formatRelative(stamp?: number | null, fallback = 'never'): string {
  const date = stampToDate(stamp);
  if (!date) return fallback;
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function scopeList(granted?: string | null): string[] {
  return (granted ?? '').split(' ').map((s) => s.trim()).filter(Boolean);
}

export function scopeLabel(scope: string): string {
  return CONNECTOR_SCOPE_LABELS[scope] ?? scope;
}

export function isWriteScope(scope: string): boolean {
  return scope.endsWith('.write');
}
